import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useGenericSend } from '@core/js/hooks/socket/hooks/useGenericSend';
import { TPlayerTag } from '@core/js/hooks/socket/hooks/useGetPlayerTags/types';
import * as Types from '@core/js/hooks/socket/hooks/useSetPlayerTags/types';

import { updatePlayerTags } from '@interlayer/js/custom/stores/user/actions';
import { fromArrayToObject } from '@interlayer/js/custom/utils/methods.util';

// Added updatePlayerTags
export const useSetPlayerTags = () => {
    const send = useGenericSend();
    const dispatch = useDispatch();

    return useCallback(async (request: Types.ISetPlayerTagsRequestData): Promise<Types.ISetPlayerTagsResponseData> => {
        const { data } = await send<Types.ISetPlayerTagsRequestData, Types.ISetPlayerTagsResponseData>({
            ID: 35544,
            description: 'Set player tags',
            responses: [35545, 35546],
            errorLevel: 1,
            ...request
        });

        const tagsObject = fromArrayToObject<TPlayerTag, 'name'>({
            data: data.tags || [],
            key: 'name'
        });

        dispatch(updatePlayerTags(tagsObject));

        return data;
    }, [dispatch, send]);
};
